import { render } from "./SidebarAccordionItem.vue?vue&type=template&id=184f418f&ts=true"
import script from "./SidebarAccordionItem.vue?vue&type=script&lang=ts"
export * from "./SidebarAccordionItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__